import React, { useState } from 'react';
import { useIsMobile } from "src/latest/src/hooks";
import { sanitiseHTML, toType } from 'src/utils/helpers';
import EditButton from '../../../../../../containers/TherapistProfile/Tabs/EditButton';
import { ViewMoreActionButton, Typography } from 'src/latest/src/components';
import './BioSection.scss';

interface Prop {
  value: any;
  secKey: string;
  showPage: any;
}

export const BioSection: React.FC<Prop> = ({ value, secKey, showPage }) => {
  const isFromMobile = useIsMobile();
  const [showAll, setShowAll] = useState(false);

  return (
    <>
      {value &&
        value?.questions?.map((question: any, index: number) => {
          return (
            <div
              key={secKey + question?.display_title + index}
              className="w-100 bio-section-container"
            >
              <EditButton section={value} showPage={showPage} />

              <Typography
                variant="size-14"
                weight="bold"
                color="color-28"
                className="new-therapist-profile__title mb-3"
              >
                {question?.display_title}
              </Typography>

              <div
                className={`bio-text-section mb-3 ${
                  showAll ? '' : isFromMobile ? 'show-less-text-mobile' : 'show-less-text'
                }`}
              >
                {toType(question?.choices) === 'array' &&
                  toType(question?.choices[0]) === 'object' && (
                    <Typography
                      variant={`size-16`}
                      weight={`regular`}
                      color="color-2"
                    >
                      {question?.choices[0]?.value ? sanitiseHTML(question?.choices[0]?.value) : 'N/A'}
                    </Typography>
                  )}
              </div>

              {question?.choices[0]?.value && (
                <ViewMoreActionButton
                  showAll={showAll}
                  setShowAll={setShowAll}
                />
              )}
            </div>
          );
        })}
    </>
  );
};
